import React from "react";
import "./Footer.css";
import { FaGithub, FaLinkedin, FaFacebookSquare } from "react-icons/fa";

const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer className="bg-gray-50 p-2">
      <div className="flex justify-center items-center gap-4 mb-2">
        <ul className="wrapper">
          <li className="icon facebook">
            <span className="tooltip1">Facebook</span>
            <a
              href="https://www.facebook.com/muntasir.tonmoy.946/"
              target="_blank"
              rel="noreferrer"
            >
              <span>
                <FaFacebookSquare></FaFacebookSquare>
              </span>
            </a>
          </li>

          <li className="icon twitter">
            <span className="tooltip1">LinkedIn</span>
            <a
              href="https://www.linkedin.com/in/md-muntasir-hossain-a18169241/"
              target="_blank"
              rel="noreferrer"
            >
              <span>
                <FaLinkedin></FaLinkedin>
              </span>
            </a>
          </li>

          <li className="icon github">
            <span className="tooltip1">Github</span>
            <a
              href="https://github.com/MuntasirTonmoy"
              target="_blank"
              rel="noreferrer"
            >
              <span>
                <FaGithub className="text-xl"></FaGithub>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <p className="text-center mb-2">
        Copyright © {year} - All right reserved
      </p>
    </footer>
  );
};

export default Footer;
